import React, { useContext } from "react";
import { SidebarContext } from "../../../contexts/SidebarContext";
import { Box, Divider, Drawer, styled, useTheme } from "@mui/material";
import SidebarMenu from "./SidebarMenu/sidebar";
import "./SidebarMenu/SideBar.scss";
import "./index.scss";
import CloseIcon from "@mui/icons-material/Close";

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        min-width: SidebarWrapper;
        color: lightgrey;
        background: rgba(215, 220, 237, 0.20);
        box-shadow: 0 0 0 2px ${theme.palette.background.paper};
        z-index: 7;
        position: relative;
        height: 100%;
        border-right: 1px solid rgba(0, 117, 201, 0.12);
        
        @media (max-width: 1040px) {
    display: none;
    
  }
`
);

const TopSection = styled(Box)(
  ({ theme }) => `
        margin: ${theme.spacing(2)};
`
);

function Sidebar({ hamburgerMenu, toggleDrawer }) {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();

  return (
    <>
      <SidebarWrapper>
        <div style={{ textAlign: "center" }}>
          {/*<img style={{height: '60px'}} src={bookstore_logo}/>*/}
          <div className="logoContainer">
            {/* <img className="filter" src={'/Journey_Logo_Alternative_Horizontal_Pantones.png'} alt="logo" /> */}
          </div>
          <div className={"logoDivider"}></div>
        </div>
        <Drawer
          anchor="left"
          open={hamburgerMenu}
          onClose={toggleDrawer}
          sx={{
            "& > .MuiPaper-root.MuiDrawer-paperAnchorLeft": {
              width: "370px",
            },
          }}
        >
          <Box
            width="40%"
            sx={{ display: "flex", width: "100%", position: "relative" }}
          >
            <Box sx={{ marginTop: "13px" }}>
              <img
                src="/Journey_Logo_Alternative_Horizontal_Pantones.png"
                alt="logo"
              />
            </Box>
            <Box
              position="absolute"
              top="10px"
              right="10px"
              onClick={toggleDrawer}
            >
              <CloseIcon />
            </Box>
          </Box>

          <Divider sx={{ mb: 2 }} />
          <div onClick={toggleDrawer}>
            <SidebarMenu />
          </div>
        </Drawer>
        <SidebarMenu />
      </SidebarWrapper>
    </>
  );
}

export default Sidebar;
